




import Vue from 'vue';
export default Vue.extend({
  props: {
    item: {
      type: Object,
      default: () => ({
        text: '',
        icon: false
      })
    }
  }
});
